export const Colors={
    primaryBg:'#f7f7f7',
    primaryColor:'#223E92',
    primaryText:'#363636',
    secondaryText:'#EB1C2F'
}